import { useEffect, useState } from 'react';
import ListView from 'src/layouts/ListView';
import { Helmet } from 'react-helmet';
import ActiveReviews from './ActiveReviews';
import CompletedReviews from './CompletedReviews';
import { useReviewsTotals } from './hooks';
import { Box, Flex, Text } from '@chakra-ui/react';
import ScrollToTopButton from '../Organization/public/Journal/SubmissionUpload/components/common/ScrollToTopButton';
import { useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer';

const TABS = {
  ACTIVE: 'Active Reviews',
  COMPLETED: 'Completed Reviews'
} as const;
type Tab = (typeof TABS)[keyof typeof TABS];

const renderTab = (tab: Tab) => {
  switch (tab) {
    case TABS.ACTIVE:
      return <ActiveReviews />;
    case TABS.COMPLETED:
      return <CompletedReviews />;
    default:
      return null;
  }
};

const ReviewList = () => {
  const { data } = useReviewsTotals();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const status = searchParams.get('reviewListType') || '';
  const selectedTab = status ? status.toUpperCase() : '';

  const [activeTab, setActiveTab] = useState<Tab>(
    selectedTab === 'COMPLETED' ? TABS[selectedTab] : TABS.ACTIVE
  );
  const getTabLabel = (tab: Tab) => {
    switch (tab) {
      case TABS.ACTIVE:
        return `${TABS.ACTIVE} ${
          data?.activeTotal ? `(${data.activeTotal})` : ''
        }`;
      case TABS.COMPLETED:
        return `${TABS.COMPLETED} ${
          data?.completedTotal ? `(${data.completedTotal})` : ''
        }`;
      default:
        return tab;
    }
  };

  useEffect(() => {
    status && navigate(`/app/reviews?${searchParams.toString()}`);
    setActiveTab(selectedTab === 'COMPLETED' ? TABS[selectedTab] : TABS.ACTIVE);
  }, [status]);
  return (
    <Box
      id="scrollable-wrapper"
      height="100%"
      overflowY="auto"
      overflowX="hidden"
    >
      <Box padding={{ base: 3, md: 5 }} minHeight="100%">
        <Flex
          flexDirection="column"
          width="100%"
          alignItems="flex-start"
          gap={3}
        >
          <Helmet>
            <title>My Reviews</title>
          </Helmet>

          <Flex
            gap={2}
            alignItems="center"
            borderBottom="1px solid"
            borderColor="neutralPrimaryBorder"
            width="100%"
            mb={2}
          >
            {Object.values(TABS).map(tab => (
              <ListView.Tab
                key={tab}
                onClick={() => setActiveTab(tab)}
                isActive={activeTab === tab}
              >
                <Text textStyle="headingLine">{getTabLabel(tab)}</Text>
              </ListView.Tab>
            ))}
          </Flex>
          {renderTab(activeTab)}
        </Flex>
      </Box>
      <Footer />
      <ScrollToTopButton />
    </Box>
  );
};

export default ReviewList;
